import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {CenteredPage} from '@freckle/school/ts/common/components/common/centered-page'
import {Routes} from '@freckle/school/ts/common/routers/routes'

export default function ForgotPassword() {
  const {t} = useSafeTranslation()
  return (
    <CenteredPage>
      <H1>{t('FORGOT_PASSWORD_SUCCESS_PAGE_TITLE')}</H1>
      <p>{t('FORGOT_PASSWORD_SUCCESS_DESCRIPTION_TEXT')}</p>
      <Link href={Routes.login()} reactRouter>
        {t('FORGOT_PASSWORD_SUCCESS_BACK_LINK_TEXT')}
      </Link>
    </CenteredPage>
  )
}
